$(document).ready(function() {
    $('#apply-filter-favorite').on('click', function() {
        let search = document.getElementById("filter-search-favorite").value;
        let divItems = document.querySelectorAll('.is-cart-item-favorite');

        if (divItems.length > 0) {
            _.each(divItems, function (input) {
                let productName = input.getAttribute('data-product-name');
                let materialNumber = input.getAttribute('data-material-number');
                if (productName.toLowerCase().includes(search.toLowerCase()) || materialNumber.toLowerCase().includes(search.toLowerCase())) {
                    input.style.display = 'block';
                } else {
                    input.style.display = 'none';
                }
            });
        }
    });

    $('#share-modal .btn-primary').on('click', (e) => {
        $('#share-modal').modal('hide');
    });
})
